import { Action, ErrorAction, Fund } from "../domain/types";
import { AppAction, TopEltifAction, TopEltifState } from "./types";
import { Observable, of } from "rxjs";
import { catchError, mergeMap } from "rxjs/operators";

import { API_URL } from "./../domain/config";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { lang } from "../../lang";

const FETCH_TOP_ELTIF_REQUESTED = "FETCH_TOP_ELTIF_REQUESTED";
const FETCH_TOP_ELTIF_SUCCESSFUL = "FETCH_TOP_ELTIF_SUCCESSFUL";
const FETCH_TOP_ELTIF_REJECTED = "FETCH_TOP_ELTIF_REJECTED";

export const fetchTopEltif = (): Action => ({
  type: FETCH_TOP_ELTIF_REQUESTED,
});

const fetchTopEltifSuccessful = (funds: Fund[]): TopEltifAction => ({
  type: FETCH_TOP_ELTIF_SUCCESSFUL,
  payload: { funds },
});

const fetchTopEltifRejected = (error: TypeError): ErrorAction => ({
  type: FETCH_TOP_ELTIF_REJECTED,
  error,
});

export default (
  state: TopEltifState = {
    id: null,
  },
  { type, payload }: TopEltifAction
) => {
  switch (type) {
    case FETCH_TOP_ELTIF_SUCCESSFUL:
      return {
        ...state,
        id: payload.funds[0]?.id || null,
      };
    default:
      return state;
  }
};

export const fetchTopEltifEpic = (
  action$: Observable<AppAction>
): Observable<Action> =>
  action$.pipe(
    ofType(FETCH_TOP_ELTIF_REQUESTED),
    mergeMap(() =>
      ajax.get(`${API_URL}/eltif/funds/?lang=${lang.getLanguage()}`).pipe(
        mergeMap(({ response }) => of(fetchTopEltifSuccessful(response))),
        catchError(error => of(fetchTopEltifRejected(error)))
      )
    )
  );
